// product-promo-popup.js révisé
document.addEventListener('DOMContentLoaded', () => {
  console.log('product-promo-popup.js loaded');

  // Sélectionner tous les boutons de modal
  const promoModalOpeners = document.querySelectorAll('.product-promo-item--popup modal-opener');
  console.log('Found modal openers:', promoModalOpeners.length);

  // Initialiser les overlays
  const overlays = document.querySelectorAll('.product-promo-popup-overlay');
  overlays.forEach(overlay => {
    // Ajouter un event listener pour la fermeture lors du clic sur l'overlay
    overlay.addEventListener('click', (event) => {
      // Empêcher la propagation du clic
      event.stopPropagation();
      
      // Trouver le modal associé à cet overlay
      const modalId = overlay.getAttribute('data-overlay-for');
      const modal = document.getElementById(modalId);
      
      if (modal) {
        // Fermer le modal
        closeModal(modal);
      }
    });
  });

  // Attacher des écouteurs d'événements aux ouvreurs de modals
  promoModalOpeners.forEach(opener => {
    opener.addEventListener('click', (event) => {
      event.preventDefault();
      console.log('Modal opener clicked:', opener);

      // Obtenir l'ID du modal à ouvrir
      const modalId = opener.getAttribute('data-modal').substring(1); // Enlève le # au début
      const modal = document.getElementById(modalId);

      if (modal) {
        console.log('Modal found:', modal);
        openModal(modal);
      } else {
        console.error('Modal not found:', modalId);
      }
    });
  });

  // Attacher des écouteurs d'événements aux boutons de fermeture
  const closeButtons = document.querySelectorAll('.product-promo-popup-modal__close');
  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      const modal = button.closest('modal-dialog');
      if (modal) {
        console.log('Closing modal:', modal);
        closeModal(modal);
      }
    });
  });

  // Fermeture avec la touche Escape
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const openModals = document.querySelectorAll('modal-dialog[open]');
      openModals.forEach(modal => {
        closeModal(modal);
      });
    }
  });

  // Déplacer les overlays à la racine du document pour éviter les problèmes de z-index
  moveOverlaysToRoot();

  // Fonction pour ouvrir un modal
  function openModal(modal) {
    // Trouver l'overlay correspondant à ce modal
    const modalId = modal.getAttribute('id');
    const overlay = document.querySelector(`.product-promo-popup-overlay[data-overlay-for="${modalId}"]`);
    
    if (overlay) {
      // Activer l'overlay
      overlay.classList.add('active');
      overlay.style.display = 'block';
      
      // Désactiver le défilement du corps
      document.body.classList.add('popup-active');
      
      // Injecter le contenu de la page si nécessaire
      const pageContentContainer = modal.querySelector('.popup-page-content');
      if (pageContentContainer) {
        const pageContentId = pageContentContainer.getAttribute('data-page-content-id');
        const template = document.querySelector(`#page-content-template-${pageContentId}`);
        if (template) {
          pageContentContainer.innerHTML = template.innerHTML;
          pageContentContainer.style.display = 'block';
        }
      }
      
      // Ouvrir le modal
      if (typeof modal.show === 'function') {
        modal.show();
      } else {
        modal.setAttribute('open', '');
        modal.style.display = 'block';
      }
    } else {
      console.error('Overlay not found for modal:', modalId);
    }
  }

  // Fonction pour fermer un modal
  function closeModal(modal) {
    // Trouver l'overlay correspondant à ce modal
    const modalId = modal.getAttribute('id');
    const overlay = document.querySelector(`.product-promo-popup-overlay[data-overlay-for="${modalId}"]`);
    
    if (overlay) {
      // Désactiver l'overlay
      overlay.classList.remove('active');
      overlay.style.display = 'none';
      
      // Réactiver le défilement du corps
      document.body.classList.remove('popup-active');
      
      // Vider le contenu de la page si nécessaire
      const pageContentContainer = modal.querySelector('.popup-page-content');
      if (pageContentContainer) {
        pageContentContainer.style.display = 'none';
        pageContentContainer.innerHTML = '';
      }
      
      // Fermer le modal
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
        modal.style.display = 'none';
      }
    } else {
      console.error('Overlay not found for modal:', modalId);
    }
  }

  // Fonction pour déplacer tous les overlays à la racine du document
  function moveOverlaysToRoot() {
    const allOverlays = document.querySelectorAll('.product-promo-popup-overlay');
    
    allOverlays.forEach(overlay => {
      // Vérifier si l'overlay est déjà à la racine
      if (overlay.parentNode !== document.body) {
        // Copier les attributs et les classes
        const clonedOverlay = overlay.cloneNode(true);
        
        // Ajouter un écouteur d'événements pour la fermeture
        clonedOverlay.addEventListener('click', (event) => {
          event.stopPropagation();
          const modalId = clonedOverlay.getAttribute('data-overlay-for');
          const modal = document.getElementById(modalId);
          if (modal) {
            closeModal(modal);
          }
        });
        
        // Ajouter au corps du document
        document.body.appendChild(clonedOverlay);
        
        // Supprimer l'original pour éviter les doublons
        overlay.parentNode.removeChild(overlay);
      }
    });
  }
});